module.exports = __webpack_public_path__ + "img/fis-coloured.cbc3ebed.svg";